import { useMutation } from '@tanstack/react-query';
import { ModelPrimaryKey } from '@steelbuy/ts-shared';
import axios from '../../axios';

const deleteDraftBulkUpload = async (draftId: ModelPrimaryKey) => {
    const { data } = await axios.delete<ModelPrimaryKey>(`/api/seller/bulk-listing-drafts/${draftId}`);
    return data;
};

export const useDeleteDraftBulkUpload = () =>
    useMutation({
        mutationFn: (draftId: ModelPrimaryKey) => deleteDraftBulkUpload(draftId),
    });
